import React from 'react'
import { Grid, Popup, Button } from 'semantic-ui-react'
import DeviceGrid from './DeviceGrid'
import DeviceControls from './DeviceControls'
import ConfiguratorGrid from '../lib/ConfiguratorGrid'

type ConfiguratorProps = {}

type ConfiguratorState = {
  contextMenu: {
    contextMenuOpen: boolean;
    xPosition: number;
    yPosition: number;
    isRotatable: boolean;
  };
}

class Configurator extends React.Component<any, ConfiguratorState> {
  deviceRef: React.RefObject<any>

  configuratorGrid: ConfiguratorGrid | null

  constructor(props: ConfiguratorProps) {
    super(props)
    this.deviceRef = React.createRef()
    this.configuratorGrid = null
    this.state = {
      contextMenu: {
        contextMenuOpen: false,
        xPosition: 0,
        yPosition: 0,
        isRotatable: true,
      },
    }
  }

  componentDidMount() {
    this.configuratorGrid = new ConfiguratorGrid(this.deviceRef, this.onModuleSelected, this.onModuleUnSelected, this.closeContextMenu)
    this.configuratorGrid.drawGrid()
    this.configuratorGrid.centerAndRescaleGrid()
    window.addEventListener('resize', this.configuratorGrid.updateDimensions)
  }

  componentWillUnmount() {
    if (this.configuratorGrid) {
      window.removeEventListener('resize', this.configuratorGrid.updateDimensions.bind(this.configuratorGrid))
    }
  }

  onModuleSelected = (x: number, y: number, isRotatable: boolean) => {
    this.setState({
      contextMenu: {
        xPosition: x,
        yPosition: y,
        contextMenuOpen: true,
        isRotatable,
      },
    })
  }

  closeContextMenu = (): void => {
    const { contextMenu } = this.state

    if (!contextMenu.contextMenuOpen) return

    this.setState({
      contextMenu: {
        ...contextMenu,
        contextMenuOpen: false,
      },
    })
  }


  onModuleUnSelected = () => {
    this.setState({ contextMenu: { ...this.state.contextMenu, contextMenuOpen: false } })
  }

  render(): JSX.Element {
    const { contextMenu: { contextMenuOpen, yPosition, xPosition, isRotatable } } = this.state
    return (
      <>
        <Grid.Column width={5} style={{ maxHeight: '100vh' }} stretched>
          <DeviceControls
            closeContextMenu={this.closeContextMenu}
            zoomIn={() => this.configuratorGrid?.zoomBy(1.05)}
            zoomOut={() => this.configuratorGrid?.zoomBy(0.95)}
            getDevice={() => this.configuratorGrid?.getDevice()}
            showEntireDevice={() => this.configuratorGrid?.showEntireDevice()}
          />
        </Grid.Column>
        <Grid.Column width={11} stretched>
          <DeviceGrid deviceModules={[]} deviceRef={this.deviceRef} />
          <Popup
            open={contextMenuOpen}
            className='disableTransform'
            style={{
              position: 'absolute',
              top: `${yPosition}px`,
              left: `${xPosition}px`,
              transform: 'none !important',
            }}
            trigger={(
              <div />
            )}
          >
            <Popup.Content>
              {isRotatable && (
                <>
                  <Button size='large' color='blue' icon='undo' circular onClick={() => this.configuratorGrid?.rotate(false)} />
                  <Button size='large' color='blue' icon='redo' circular onClick={() => this.configuratorGrid?.rotate(true)} />
                </>
              )}
              <Button size='large' color='red' icon='trash' circular onClick={() => this.configuratorGrid?.remove()} />
            </Popup.Content>
          </Popup>
        </Grid.Column>
      </>
    )
  }
}

export default Configurator
